import { render, staticRenderFns } from "./BlankInputLayout.vue?vue&type=template&id=6b942747&scoped=true&"
import script from "./BlankInputLayout.vue?vue&type=script&lang=js&"
export * from "./BlankInputLayout.vue?vue&type=script&lang=js&"
import style0 from "./BlankInputLayout.vue?vue&type=style&index=0&id=6b942747&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b942747",
  null
  
)

export default component.exports